import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import { useAuthStore } from '../../zustand-store/auth.store';
import { getTrustPilotConfig, updateTrustPilotConfig } from '../../axios/businessReviews';
import { toast } from 'react-toastify';

const TrustpilotDetailModal = ({ isOpen, toggle, title, description, icon }) => {
  const [trustPilotBusinessUrl, setTrustPilotBusinessUrl] = useState('');
  const [loader, setLoader] = useState(false);
  const locationId = useAuthStore((state) => state.locationId);

  useEffect(() => {
    if (isOpen) {
      getInitialConfig();
    }
  }, [locationId, isOpen]);

  const getInitialConfig = async () => {
    const response = await getTrustPilotConfig(locationId);
    setTrustPilotBusinessUrl(response?.data?.data?.trustPilotBusinessUrl || '');
  };

  const saveConfig = async () => {
    setLoader(true);
    const response = await updateTrustPilotConfig(locationId, { trustPilotBusinessUrl });
    if (response?.status === 200 || response?.status === 201) {
      toast.success('Trustpilot details saved successfully');
      toggle();
    }
    setLoader(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle} className="bg-light px-4 py-4">
        <div className="d-flex align-items-center mt-3">
          <img
            style={{
              width: '66px',
              height: '64px',
              marginRight: '20px',
              background: 'rgb(240,240,240)',
              borderRadius: '50%'
            }}
            src={icon}
            alt="icon"
            className="p-2"
          />
          <div>
            <h5 className="mb-0">{title}</h5>
            <small className="text-muted">{description}</small>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <ol>
          <li>
            <p>Open a new browser tab and log into your Trustpilot Business account.</p>
          </li>
          <li>
            <p>Go to your business profile page on Trustpilot.</p>
          </li>
          <li>
            <p>Copy the URL of your business profile and paste it in the field below.</p>
          </li>
        </ol>
        <div className="mx-3">
          <input
            name="trustpilot-url"
            placeholder="https://www.trustpilot.com/review/yourbusiness.com"
            className="form-control"
            value={trustPilotBusinessUrl}
            onChange={(e) => setTrustPilotBusinessUrl(e.target.value)}
          />
          <p>ex: https://www.trustpilot.com/review/example.com</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={saveConfig}
          disabled={loader || trustPilotBusinessUrl.trim() === ''}>
          {loader ? (
            <>
              <Spinner size="sm" /> {' Loading...'}
            </>
          ) : (
            'Update'
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

TrustpilotDetailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.any
};

export default TrustpilotDetailModal;
